// 单位换算工具类
/*
 * @desc 元 -> 分
 * @return
 */
export function yuanToCents(value) {
  if (isNaN(value)) {
    return ''
  }
  return value *= 100;
}

/*
 * @desc 分 -> 元
 * @return
 */
export function centsToYuan(value) {
  console.log(value)
  if (isNaN(value)) {
    return ''
  }
  return value /= 100;
}
/*
 * @desc kg -> g
 * @return
 */
export function kgToG(value) {
  if (isNaN(value)) {
    return ''
  }
  return value *= 1000;
}
/*
 * @desc g -> kg
 * @return
 */
export function gToKg(value) {
  if (isNaN(value)) {
    return ''
  }
  return value /= 1000;
}